import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Visibility, VisibilityOff } from '@mui/icons-material/';
import { LinearProgress, Stack } from '@mui/material/';
import { toaster } from 'evergreen-ui';
import logo from '../../assets/METIOR.png';
import authentication from '../../api/authentication';

const SignUp = ({ setUser }) => {
  const [newUser, setNewUser] = useState({
    firstname: '',
    lastname: '',
    password: '',
    email: '',
    acceptOffers: true,
    profile: {
      profile: 'user.png', base64: '', type: 'image/x-png',
    },
    company: '',
    company_logo: {
      filename: '',
      base64: '',
      type: 'image/x-png',
    },
    currency: 'MXN',
  });
  const [isPasswordVisible, setIsPasswordVisible] = useState('password');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignUp = (e) => {
    e.preventDefault();
    document.getElementById('submit-button').classList.add('loading-button');
    setTimeout(async () => {
      setIsLoading(true);
      const signedUp = await authentication.signUp(newUser);
      if (signedUp?.User?.createdAt) {
        const logedIn = await authentication.logIn(newUser);
        if (logedIn?.token) {
          localStorage.setItem('token', logedIn.token);
          localStorage.setItem('id', logedIn.user);
          localStorage.setItem('user-name', logedIn.firstname);
          setUser(true);
          toaster.success('cuenta creada con exito', {
            id: 'forbidden-action',
            duration: 3,
          });
          navigate('/metior');
        } else {
          setIsLoading(false);
          document.getElementById('submit-button').classList.remove('loading-button');
          toaster.danger(logedIn?.message, {
            id: 'forbidden-action',
            duration: 3,
          });
        }
      } else {
        setIsLoading(false);
        document.getElementById('submit-button').classList.remove('loading-button');
        toaster.danger('este usuario ya existe', {
          id: 'forbidden-action',
          duration: 3,
        });
      }
    }, 150);
  };

  useEffect(() => {
    document.getElementsByClassName('signup-container')[0].style.height = `${window.innerHeight}px`;
  }, []);

  return (
    <div
      className="signup-container"
      style={{ backgroundColor: '#2d2e2e' }}
    >
      {isLoading
      && (
        <Stack
          sx={{
            width: '100%', color: 'grey.500', position: 'fixed', top: '0',
          }}
          spacing={2}
        >
          <LinearProgress color="inherit" />
        </Stack>
      )}

      <div className="content-signup">
        <h4>Crea tu Cuenta</h4>
        <h5>
          Metior es un sistema que te facilitara obtener los costos y precio de venta de tus proyectos.
        </h5>
        <p>- Calcula los costos de tus proyectos</p>
        <p>- Administra tus proyectos y los de tu cliente</p>
        <p>- Genera cotizaciones para usted o para tu cliente</p>
      </div>

      <form className="authentication-form" onSubmit={(e) => handleSignUp(e)}>
        <div className="metior">
          <p>UNETE A</p>
          <img width="100px" height="100%" alt="metior" src={logo} />
        </div>
        <label aria-label="userName" htmlFor="name">Nombre</label>
        <input
          className="select"
          type="text"
          id="name"
          required
          value={newUser.firstname}
          onChange={(e) => setNewUser((prevState) => ({ ...prevState, firstname: e.target.value }))}
        />
        <label aria-label="userName" htmlFor="lastName">Apellido</label>
        <input
          className="select"
          type="text"
          id="lastName"
          required
          value={newUser.lastname}
          onChange={(e) => setNewUser((prevState) => ({ ...prevState, lastname: e.target.value }))}
        />
        <label aria-label="userName" htmlFor="email">Correo</label>
        <input
          className="select"
          type="email"
          id="email"
          required
          value={newUser.email}
          onChange={(e) => setNewUser((prevState) => ({ ...prevState, email: e.target.value }))}
        />
        <label aria-label="userName" htmlFor="password">Contraseña</label>
        <div style={{ position: 'relative' }}>
          <input
            className="select"
            type={isPasswordVisible}
            id="password"
            required
            value={newUser.password}
            onChange={(e) => setNewUser((prevState) => ({ ...prevState, password: e.target.value }))}
          />
          <button
            style={{ position: 'absolute' }}
            className="password-button"
            type="button"
            onClick={() => {
              if (isPasswordVisible === 'password') {
                setIsPasswordVisible('text');
              } else {
                setIsPasswordVisible('password');
              }
            }}
          >
            {isPasswordVisible === 'password' ? <Visibility /> : <VisibilityOff />}
          </button>
        </div>
        <div className="justify-align-items">
          <p>¿Deseas recibir ofertas?</p>
          <input
            type="checkbox"
            defaultChecked
            onChange={(e) => setNewUser((prevState) => ({ ...prevState, acceptOffers: e.target.checked }))}
          />
        </div>
        {isLoading
          ? (
            <Stack sx={{ width: '200px', color: 'grey.500', margin: '33px 60px' }} spacing={2}>
              <LinearProgress color="inherit" />
            </Stack>
          )
          : (
            <button onTransitionEnd={() => {}} id="submit-button" className="select-button" type="submit">
              CREAR CUENTA
            </button>
          )}
        <Link className="login-signup-link" to="/metior/login">
          <span>¿Ya tienes cuenta en Metior? Inicia sesion</span>
        </Link>
      </form>
    </div>
  );
};

SignUp.propTypes = {
  setUser: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  setUser: (values) => dispatch({
    type: 'SET_USER',
    payload: values,
  }),
});

export default connect(null, mapDispatchToProps)(SignUp);
